export default class AuthRequest {
    username;
    password;

    fromJson = (json={})=> {
        var authRequest = new AuthRequest();
        authRequest = json;
        return authRequest
    }
}